import client from './client';
import { Product, ProductMutationPayload, ProductTemplate } from '../types';

export const getProducts = async (storeId?: string): Promise<Product[]> => {
    const params = storeId ? { storeId } : {};
    const response = await client.get('products', { params });
    return response.data;
};

export const getAdminProducts = async (): Promise<Product[]> => {
    const response = await client.get('products/admin');
    return response.data;
};

export const getAdminProduct = async (id: string): Promise<Product | null> => {
    const response = await client.get(`products/admin/${id}`);
    return response.data;
};

export const createProduct = async (product: ProductMutationPayload) => {
    const response = await client.post('products/admin', product);
    return response.data;
};

export const updateProduct = async (id: string, updates: ProductMutationPayload) => {
    const response = await client.patch(`products/admin/${id}`, updates);
    return response.data;
};

export const deleteProduct = async (id: string) => {
    const response = await client.delete(`products/admin/${id}`);
    return response.data;
};

export const bumpProduct = async (id: string) => {
    const response = await client.patch(`products/admin/${id}/bump`);
    return response.data;
};

export const getProductTemplates = async (): Promise<ProductTemplate[]> => {
    const response = await client.get('products/admin/templates');
    return response.data;
};

export const saveProductTemplate = async (productId: string): Promise<ProductTemplate> => {
    const response = await client.post(`products/admin/${productId}/template`);
    return response.data;
};

export const updateProductTemplate = async (
    templateId: string,
    updates: ProductMutationPayload,
): Promise<ProductTemplate> => {
    const response = await client.patch(`products/admin/templates/${templateId}`, updates);
    return response.data;
};

export const deleteProductTemplate = async (templateId: string) => {
    const response = await client.delete(`products/admin/templates/${templateId}`);
    return response.data;
};
